import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptionBell2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="receiption-bell-2, concierge, assistant"><path d="M3 19.25H21" stroke="currentColor" strokeWidth="1.5"/><path d="M12 16.5V18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 7.5V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 4.75L15 4.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 7.5C7 7.5 3.75 11.4175 3.75 16.25H20.25C20.25 11.4175 17 7.5 12 7.5Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconReceiptionBell2;
